import React from 'react';
import { FaCheckCircle, FaTimesCircle, FaQuestionCircle } from 'react-icons/fa';
 
const QuoteStatusCell = ({ line }) => {
    const iconStyle = {
        fontSize: '1.4em', // Adjust size if needed
    };
 
    let IconComponent;
    let statusText;
    let color;
 
    switch (line.nyc_quoteproductstatus) {
        case 219640000:
            IconComponent = FaCheckCircle;
            statusText = 'Approved';
            color = 'green';
            break;
        case 219640001:
            IconComponent = FaTimesCircle;
            statusText = 'Rejected';
            color = 'red';
            break;
        default:
            IconComponent = FaQuestionCircle;
            statusText = 'Under Review';
            color = '#FABC3F';
            break;
    }
 
    return (
        <td style={{ color }}>
            <div className='flex flex-col justify-center items-center w-full'>
                <IconComponent style={iconStyle} aria-hidden="true" />
                {statusText}
            </div>
        </td>
    );
};
 
export default QuoteStatusCell;
